exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EmptyCardItem-module__carditem-background___3fHqk{width:174px;height:40px;border-radius:2px;margin:0 0 5px;background:rgba(0,0,0,.1);display:flex;justify-content:flex-start;box-sizing:border-box;padding:7px;font-family:Montserrat,\"sans-serif\";position:relative;cursor:pointer}.EmptyCardItem-module__carditem-background___3fHqk.EmptyCardItem-module__weekend___2cuMY{background:rgba(0,0,0,.04)}.EmptyCardItem-module__carditem-background___3fHqk.EmptyCardItem-module__weekend___2cuMY.EmptyCardItem-module__dragging___g6daW{background-color:rgba(0,0,0,.1)}", ""]);

// exports
exports.locals = {
	"carditem-background": "EmptyCardItem-module__carditem-background___3fHqk",
	"weekend": "EmptyCardItem-module__weekend___2cuMY",
	"dragging": "EmptyCardItem-module__dragging___g6daW"
};